import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { Event } from '@ifeng/ui_base';
import { handleAd } from '@ifeng/ui_pc_ad';
import errorBoundary from '@ifeng/errorBoundary';
import ListTitle from '../listTitle';
import { rel } from '../../../utils/rel';

const formatList = (list, ads) => {
    for (const ad of ads) {
        if (ad.type === 'replaceArr') {
            list.splice(ad.index, 1, [{ type: 'ad', ref: ad.ref }]);
        } else if (ad.type === 'insertArr') {
            list.splice(ad.index, 0, [{ type: 'ad', ref: ad.ref }]);
        }
    }

    return list;
};

class NewsList extends React.PureComponent {
    static propTypes = {
        content: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        hasTopic: PropTypes.bool,
        hasTitle: PropTypes.bool,
        isContent: PropTypes.bool,
        isList: PropTypes.bool,
        ad: PropTypes.object,
    };

    state = {
        ads: [],
    };

    event = new Event();

    insert = (insertArr, replaceArr, adFn) => {
        if (adFn && typeof adFn === 'function') {
            const refs = [];

            replaceArr.forEach(index => {
                const ref = React.createRef();

                refs.push({ index, ref, type: 'replaceArr' });
            });

            insertArr.forEach(index => {
                const ref = React.createRef();

                refs.push({ index, ref, type: 'insertArr' });
            });

            this.setState(
                {
                    ads: [...this.state.ads, ...refs],
                },
                () => {
                    const dom = {};

                    for (const ref of refs) {
                        dom[ref.index] = ref.ref.current;
                    }

                    adFn(dom);
                },
            );
        }

        return;
    };

    async componentDidMount() {
        const { ad } = this.props;

        if (ad) {
            try {
                const callback = await handleAd(ad);

                callback(ad.data, this.event, this.insert);
            } catch (e) {
                console.error(e);
            }

            try {
                this.event.trigger('init');
            } catch (e) {
                console.error(e);
            }
        }
    }

    render() {
        const { ads } = this.state;
        const { content, hasTopic, hasTitle, isContent, isList } = this.props;
        let videoContent = [];
        let data = content instanceof Array ? content : [content];

        data = formatList(data, ads);

        if (hasTitle) {
            videoContent = data.slice(0, 1);
            data = data.slice(1);
        }

        let styleName = 'news_list';

        if (isContent) styleName = 'content_list';

        if (isList) styleName = 'list';

        /* eslint-disable no-confusing-arrow */
        return (
            <ul className={styles[styleName]}>
                {hasTitle ? <ListTitle content={videoContent} /> : ''}
                {data.map((item, index) => {
                    if (item.type === 'ad') return <li key={index} ref={item.ref} />;

                    if (item.isHidden === '1') return '';

                    const markStyle = [];
                    let hasZoujc = false;
                    let isCNRed = false;

                    if (item.pcNewsMark && item.pcNewsMark.length > 0) {
                        for (const i of item.pcNewsMark) {
                            if (i === 1) {
                                markStyle.push(styles.bold);
                            } else if (i === 2) {
                                markStyle.push(styles.video);
                            } else if (i === 3) {
                                hasZoujc = true;
                            } else if (i === 4) {
                                isCNRed = true;
                            }
                        }
                    }

                    return index === 0 && hasTopic ? (
                        <li key={index} className={styles.topic}>
                            <h1>
                                {hasZoujc ? <span className={styles.zoujc} /> : ''}
                                {item.children && item.children.length > 0 ? (
                                    <React.Fragment>
                                        <a
                                            className={isCNRed ? styles.cnRed : ''}
                                            href={item.url}
                                            target="_blank"
                                            rel={rel}>
                                            {item.title}
                                        </a>
                                        {item.children.map((item, index) => (
                                            <React.Fragment key={index}>
                                                <a
                                                    className={
                                                        item.pcNewsMark && item.pcNewsMark.includes(4)
                                                            ? styles.cnRed
                                                            : ''
                                                    }
                                                    href={item.url}
                                                    target="_blank"
                                                    rel={rel}>
                                                    {item.title}
                                                </a>
                                            </React.Fragment>
                                        ))}
                                    </React.Fragment>
                                ) : (
                                    <a
                                        className={isCNRed ? styles.cnRed : ''}
                                        href={item.url}
                                        target="_blank"
                                        rel={rel}>
                                        {item.title}
                                    </a>
                                )}
                            </h1>
                        </li>
                    ) : (
                        <li key={index} className={markStyle.join(' ')}>
                            {hasZoujc ? <span className={styles.zoujc} /> : ''}
                            {item.children && item.children.length > 0 ? (
                                <React.Fragment>
                                    <a
                                        className={isCNRed ? styles.cnRed : ''}
                                        href={item.url}
                                        target="_blank"
                                        rel={rel}>
                                        {item.title}
                                    </a>
                                    {item.children.map((item, index) => (
                                        <React.Fragment key={index}>
                                            <a
                                                className={
                                                    item.pcNewsMark && item.pcNewsMark.includes(4) ? styles.cnRed : ''
                                                }
                                                href={item.url}
                                                target="_blank"
                                                rel={rel}>
                                                {item.title}
                                            </a>
                                        </React.Fragment>
                                    ))}
                                </React.Fragment>
                            ) : (
                                <a className={isCNRed ? styles.cnRed : ''} href={item.url} target="_blank" rel={rel}>
                                    {item.title}
                                </a>
                            )}
                        </li>
                    );
                })}
            </ul>
        );
        /* eslint-enable no-confusing-arrow */
    }
}

export default errorBoundary(NewsList);
